import append from 'ramda/src/append'
import partition from 'ramda/src/partition'
import find from 'ramda/src/find'
import omit from 'ramda/src/omit'
import isEmpty from 'ramda/src/isEmpty'
import propEq from 'ramda/src/propEq'
import pipe from 'ramda/src/pipe'
import reject from 'ramda/src/reject'
import filter from 'ramda/src/filter'
import __ from 'ramda/src/__'
import identity from 'ramda/src/identity'
import reduce from 'ramda/src/reduce'

const rejectSound = (rejectedSound) => {
	if (rejectedSound.soundId) {
		return reject(propEq('soundId', rejectedSound.soundId))
	}
	return identity
}

const rejectDuplicates = reduce((acc, item) => {
	const { bitsId } = item
	const itemFound = find(propEq('bitsId', bitsId), acc)
	if (!itemFound) {
		return [...acc, item]
	}
	if (itemFound.soundId) {
		return acc
	}
	return [...reject(propEq('bitsId', itemFound.bitsId), acc), item]
}, [])

const appendSound = (addedSound, rejectedSound) => append({
	soundId: addedSound.soundId,
	label: rejectedSound.label,
	bitsId: rejectedSound.bitsId,
	audioSrc: addedSound.audioSrc,
	soundLabel: addedSound.soundLabel,
	amount: rejectedSound.amount,
})

export default ({ option, sound, pledgeOptions, addedSound, deletedSound }) => {
	if (deletedSound) {
		return pipe(
			find(propEq('soundId', deletedSound.id)),
			omit(['soundId', 'audioSrc', 'soundLabel']),
			append(__, pledgeOptions),
			filter(snd => snd.soundId !== deletedSound.id),
		)(pledgeOptions)
	}

	if (addedSound) {
		const newOption = find(propEq('soundId', undefined), pledgeOptions)
		const { id, audioSrc, name } = addedSound
		return pipe(
			filter(opt => opt !== newOption),
			append({ ...newOption, soundId: id, audioSrc, soundLabel: name }),
			reject(isEmpty),
		)(pledgeOptions)
	}

	const oldSound = find(propEq('label', option), pledgeOptions)
	const newSound = find(propEq('soundId', sound.soundId), pledgeOptions)

	if (newSound) {
		return pipe(
			rejectSound(newSound),
			rejectSound(oldSound),
			appendSound(oldSound, newSound),
			appendSound(newSound, oldSound),
			rejectDuplicates,
		)(pledgeOptions)
	}

	const [pickedOption, otherOptions] = partition(propEq('label', option), pledgeOptions)
	const { label: soundLabel, soundId, audioSrc } = sound
	const newOption = { ...pickedOption[0], soundLabel, soundId, audioSrc }
	return [...otherOptions, newOption]
}
